var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2206_1879",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2206_1879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home_2",
    d: "M5.00001 15.8332H7.78849V11.6345C7.78849 11.4211 7.86067 11.2422 8.00503 11.0979C8.14939 10.9535 8.32828 10.8813 8.5417 10.8813H11.4583C11.6717 10.8813 11.8506 10.9535 11.995 11.0979C12.1393 11.2422 12.2115 11.4211 12.2115 11.6345V15.8332H15V8.46145C15 8.41872 14.9907 8.37999 14.972 8.34526C14.9533 8.31054 14.9279 8.27983 14.8958 8.25312L10.1523 4.68741C10.1095 4.65002 10.0588 4.63133 10 4.63133C9.94125 4.63133 9.89049 4.65002 9.84776 4.68741L5.10418 8.25312C5.07213 8.27983 5.04676 8.31054 5.02805 8.34526C5.00936 8.37999 5.00001 8.41872 5.00001 8.46145V15.8332ZM3.75003 15.8332V8.46145C3.75003 8.22294 3.80338 7.99698 3.91009 7.78358C4.0168 7.57017 4.1643 7.39443 4.35259 7.25635L9.09618 3.68264C9.35941 3.48178 9.66026 3.38135 9.99872 3.38135C10.3372 3.38135 10.6389 3.48178 10.9038 3.68264L15.6474 7.25635C15.8357 7.39443 15.9832 7.57017 16.0899 7.78358C16.1966 7.99698 16.25 8.22294 16.25 8.46145V15.8332C16.25 16.174 16.1269 16.4676 15.8806 16.7138C15.6343 16.9601 15.3408 17.0832 15 17.0832H11.7148C11.5014 17.0832 11.3225 17.011 11.1781 16.8667C11.0337 16.7223 10.9616 16.5434 10.9616 16.33V12.1313H9.03847V16.33C9.03847 16.5434 8.96629 16.7223 8.82193 16.8667C8.67755 17.011 8.49866 17.0832 8.28526 17.0832H5.00001C4.6592 17.0832 4.36568 16.9601 4.11943 16.7138C3.87316 16.4676 3.75003 16.174 3.75003 15.8332Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a2c5094e0d56e23fa189f9cf7afa4caf.svg";
export { ForwardRef as ReactComponent };